export var Case = /* @__PURE__ */ ((Case2) => {
  Case2[Case2["camel"] = 0] = "camel";
  Case2[Case2["snake"] = 1] = "snake";
  return Case2;
})(Case || {});
export var HTTPMethod = /* @__PURE__ */ ((HTTPMethod2) => {
  HTTPMethod2["head"] = "head";
  HTTPMethod2["get"] = "get";
  HTTPMethod2["post"] = "post";
  HTTPMethod2["put"] = "put";
  HTTPMethod2["patch"] = "patch";
  HTTPMethod2["delete"] = "delete";
  HTTPMethod2["connect"] = "connect";
  HTTPMethod2["options"] = "options";
  HTTPMethod2["trace"] = "trace";
  return HTTPMethod2;
})(HTTPMethod || {});
export var HTTPError = /* @__PURE__ */ ((HTTPError2) => {
  HTTPError2["AbortError"] = "AbortError";
  return HTTPError2;
})(HTTPError || {});
export class FetchError extends Error {
  name = "FetchError";
  context;
  body;
  from(context, body) {
    this.context = context;
    this.body = body;
    return this;
  }
  with(error) {
    if (error) {
      this.name = error.name;
      this.stack = error.stack;
    }
    return this;
  }
}
export class RequestError extends FetchError {
  name = "RequestError";
}
export class ResponseError extends FetchError {
  name = "ResponseError";
}
